import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import {
  csColorAction,
  csColorBackground,
  csColorBorder,
  csColorFunctional
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const mollieCreditCardStyle = css`
  .csc-mollie-creditcard {
    margin-top: ${csSpacing.spacing05};
  }

  /* Styles for Mollie Credit Card fields */

  /*  Layout */
  #mollie-card-mount {
    display: grid;
    grid-template:
      "cardNumber cardNumber"
      "cardHolder cardHolder"
      "expiryDate verificationCode";
    gap: 10px
  }

  .mollie-card-component {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  /* Input field */
  .mollie-component {
    position: relative;
    background: ${csColorBackground.primary};
    border-radius: 3px;
    border: 1px solid ${csColorBorder.light};
    padding: 7px 10px
  }

  .mollie-component--cardNumber {
    padding-right: 33px;
  }

  .mollie-component.is-touched.is-invalid::after, .mollie-component.is-touched.is-valid::after {
    font: var(--fa-font-regular);
    line-height: 1;
    position: absolute;
    right: 10px;
    top: 12px;
  }

  .mollie-component.is-touched.is-invalid {
    border-color: ${csColorFunctional.error};
  }

  .mollie-component.is-touched.is-invalid::after {
    color: ${csColorFunctional.error};
    content: "\f057";
  }

  .mollie-component.is-touched.is-valid {
    border-color: ${csColorFunctional.success};
  }

  .mollie-component.is-touched.is-valid::after {
    color: ${csColorFunctional.success};
    content: "\f058";
  }

  .mollie-component.has-focus {
    border-color: ${csColorAction.linkPrimary};
  }

  /* Labels and errors */
  .mollie-card-component__label {
    font-size: 14px;
    font-weight: 700;
    line-height: 1.5;
  }

  .mollie-card-component__error {
    font-size: 12px;
    line-height: 16px;
    color: ${csColorFunctional.error};
  }

  /* Grid areas */
  .mollie-card-component--cardHolder {
    grid-area: cardHolder
  }

  .mollie-card-component--cardNumber {
    grid-area: cardNumber
  }

  .mollie-card-component--expiryDate {
    grid-area: expiryDate
  }

  .mollie-card-component--verificationCode {
    grid-area: verificationCode
  }
`
